import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
} from '@angular/core';
import { PaginationComponent } from '@frk/eds-components';
import { EDSPaginationPageChangedEvent } from 'src/app/types/shared.type';
import {
  GermanCalculatorTableData,
  GermanCalculatorTotalPages,
} from '../../types/german-calculator.type';

@Component({
  selector: 'ft-gc-result-table-data',
  templateUrl: './gc-result-table-data.component.html',
  styleUrls: ['./gc-result-table-data.component.scss'],
})
export class GcResultTableDataComponent implements OnChanges {
  @Input() tableData: GermanCalculatorTableData;
  @Input() totalPages: GermanCalculatorTotalPages;
  @Input() currentPageBody: string[][];
  @Input() prevPageText: string;
  @Input() nextPageText: string;
  @Input() ariaLabelGoToPage: string;
  @Output() selectedPage = new EventEmitter<number>();

  totalPageCount: number;
  tableBody: string[][];

  @ViewChild(PaginationComponent, { static: false })
  paginationComponent: PaginationComponent;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(): void {
    this.totalPageCount = this.totalPages?.count;
    this.tableBody = this.currentPageBody;
    this.cdr.detectChanges();
  }

  /**
   * Trigger page change with the page number selected.
   * @param event page changed event generated
   */
  onPageChanged(event: EDSPaginationPageChangedEvent): void {
    this.selectedPage.next(event.page);
  }
}
